import { commerceText, type CommerceCopy } from "./text";
import { createShopifyAdapter } from "./shopify";
import { createWooCommerceAdapter } from "./woocommerce";
import type { CommerceAdapter, CommerceConfig } from "./types";

/**
 * Adaptorul potrivit platformei din config - singurul loc din SDK care alege
 * între magazine.
 *
 * `sdk.ts` nu mai știe ce platforme există: primește configul de la /config și
 * cere un adaptor. O platformă nouă e un `case` aici plus un fișier lângă,
 * nimic altundeva - exact promisiunea făcută de interfața `CommerceAdapter`
 * (docs/plan-commerce-actions.md §5).
 *
 * `readCommerceConfig` a validat deja platforma: o valoare necunoscută n-a
 * ajuns până aici (întoarce `null`, adică „situl nu e magazin"). `switch`-ul
 * rămâne exhaustiv, deci a treia platformă nu poate fi adăugată în tipuri fără
 * să fie adăugată și aici.
 */
export function createCommerceAdapter(
  config: CommerceConfig,
  copy: CommerceCopy = commerceText(),
): CommerceAdapter {
  switch (config.platform) {
    case "woocommerce":
      return createWooCommerceAdapter(config, copy);
    case "shopify":
      return createShopifyAdapter(config, copy);
  }
}
